import { lazy } from "react";
import type { Modul } from "../../kern/modul";

const Termine = lazy(() => import("./Termine").then((m) => ({ default: m.Termine })));

/** Oberfläche für die Termine des Kerns (app_termine). Sitzung und Protokolle kommen mit dem Modul sitzung, Sprints mit dem Modul aufgaben.
 *  In der Navigation ein Reiter von „Sitzungen“ (BAUPLAN-PAKETE.md, Abschnitt 5.2). */
export const termine: Modul = {
  id: "termine",
  name: "Termine",
  routen: [{ pfad: "/termine", seite: Termine, recht: "termine.verwalten" }],
  navigation: [{ bereich: "vorstand", gruppe: "Sitzungen", label: "Termine", pfad: "/termine", icon: "termine", recht: "termine.verwalten", reihenfolge: 6 }],
  ereignisse: ["termine.angelegt", "termine.verschoben", "termine.bearbeitet", "termine.abgesagt", "termine.absage_zurueck"],
};
